import { nanoid } from "nanoid";

import type { ReviewQuestion } from "../../../pages/Administration/Reviews/EditForm/utils";

import type { FormQuestionSuggestionWithId } from "../types";

/** Convert a question suggestion emitted by the form agent into a
 *  ReviewQuestion shape ready for `useEditFormStore.addQuestion()`. */
export const questionSuggestionToReviewQuestion = (suggestion: FormQuestionSuggestionWithId): ReviewQuestion => {
	const base: Record<string, unknown> = {
		refId: nanoid(),
		type: suggestion.type,
		question: suggestion.question,
		subtext: suggestion.subtext ?? "",
		is_required: suggestion.is_required,
	};

	if (suggestion.type === "rating-scale" && suggestion.rating_scale) {
		// Rating-scale: choices is an array of { value, name, description? }
		base.choices = suggestion.rating_scale.map((opt) => ({
			value: opt.value,
			name: opt.name,
			...(opt.description ? { description: opt.description } : {}),
		}));
	} else if ((suggestion.type === "multiple-choice" || suggestion.type === "multiple-select") && suggestion.choices) {
		// Multiple-choice / multiple-select: choices is an array of strings
		base.choices = suggestion.choices;
	}

	if (suggestion.add_scaling) {
		base.add_scaling = suggestion.add_scaling.map((opt) => ({
			value: opt.value,
			name: opt.name,
			...(opt.description ? { description: opt.description } : {}),
		}));
	}

	if (suggestion.min !== undefined) base.min = suggestion.min;
	if (suggestion.max !== undefined) base.max = suggestion.max;
	if (suggestion.decimals !== undefined) base.decimals = suggestion.decimals;

	return base as ReviewQuestion;
};
